// extracted by mini-css-extract-plugin
export default {"job_heading":"JoinOurTeam_View_job_heading__mIIJd","responsivepadding":"JoinOurTeam_View_responsivepadding__4N8kD"};